export const telephone = {
  number: '020 3011 1002',
  link: '+442030111002',
}

export const addressLine1 = 'Unit 2 Issigonis House'
export const addressLine2 = 'London'
export const postcode = 'W3 7UN'
export const email = 'info@gousto.co.uk'

// eslint-disable-next-line import/no-default-export
export default {
  telephone,
  addressLine1,
  addressLine2,
  postcode,
  email,
}
